import { render, staticRenderFns } from "./approve.vue?vue&type=template&id=6d43158d&scoped=true&"
import script from "./approve.vue?vue&type=script&lang=js&"
export * from "./approve.vue?vue&type=script&lang=js&"
import style0 from "./approve.vue?vue&type=style&index=0&id=6d43158d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d43158d",
  null
  
)

export default component.exports